import type { CommunicationInboxItem, CommunicationSortField } from "@/types/communications";
import type { SortDirection } from "@/hooks/use-view-preferences";

export function filterCommunicationItems(
  items: CommunicationInboxItem[],
  query: string
): CommunicationInboxItem[] {
  const q = query.trim().toLowerCase();
  if (!q) return items;
  return items.filter((item) => {
    const subject = (item.subject || "").toLowerCase();
    const from = (item.from || "").toLowerCase();
    const preview = (item.preview || "").toLowerCase();
    const to = (item.to || "").toLowerCase();
    return subject.includes(q) || from.includes(q) || preview.includes(q) || to.includes(q);
  });
}

export function sortCommunicationItems(
  items: CommunicationInboxItem[],
  sortField: CommunicationSortField,
  sortDirection: SortDirection
): CommunicationInboxItem[] {
  const sorted = [...items].sort((a, b) => {
    let cmp = 0;
    if (sortField === "date") {
      cmp = new Date(a.date).getTime() - new Date(b.date).getTime();
    } else if (sortField === "subject") {
      cmp = (a.subject || "").localeCompare(b.subject || "");
    } else if (sortField === "from") {
      cmp = (a.from || "").localeCompare(b.from || "");
    }
    return sortDirection === "asc" ? cmp : -cmp;
  });
  return sorted;
}
